'use client';

import 'react-datepicker/dist/react-datepicker.css';

import { useMemo } from 'react';
import clsx from 'classnames';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { pl, sk, cs, de } from 'date-fns/locale';

import styles from './DatePicker.module.scss';

export const DatePicker = ({ popperClassName, locale, ...props }: ReactDatePickerProps) => {
	const popperClassNames = clsx(styles['datePicker-popper'], popperClassName);

	const fnsLocale = useMemo(() => {
		switch (locale) {
			case 'pl-PL':
				return pl;
			case 'sk-SK':
				return sk;
			case 'cs-CZ':
				return cs;
			case 'de-DE':
				return de;
			default:
				return pl;
		}
	}, [locale]);

	/** @ts-ignore **/
	return <ReactDatePicker popperClassName={popperClassNames} {...props} locale={fnsLocale} />;
};
